/**
 * 提交按钮
 */
import React, { memo, useMemo } from 'react';
import { connect } from 'react-redux';
import { Button } from 'antd';
import intl from 'react-intl-universal';

import { createStateSelector } from '@/redux/actions/reservation/helper';
import { ReducerState, storeName } from '@/redux/reducers/reversal/goods';
import { isEqualVal } from '@/components/Order/GoodsRefundModal/helper';

const stateSelector = (state: ReducerState) => {
  const { goodsList } = state;
  return { goodsList };
};
const mapStateToProps = createStateSelector<ReducerState>(storeName, stateSelector);
const mapDispatchToProps = {};

type MapStateProps = ReturnType<typeof stateSelector>;
type MapDispatchProps = typeof mapDispatchToProps;

interface IProps extends MapStateProps, MapDispatchProps {
  onClick: () => void;
}

const Index: React.FC<IProps> = (props) => {
  const { goodsList, onClick } = props;

  // 数据是否一致
  const isSame = useMemo(() => {
    let result = true;
    if (goodsList && goodsList.length) {
      result = goodsList.every((item) => {
        // 数量一致 且 小计一致
        return (
          isEqualVal(item.initCount, item.currentCount) &&
          isEqualVal(item.initTotalValue, item.currentTotalValue)
        );
      });
    }
    return result;
  }, [goodsList]);

  const handleSubmitClick = () => {
    if (isSame) return;
    onClick();
  };

  return (
    <Button type="primary" disabled={isSame} onClick={handleSubmitClick}>
      {intl.get('reversal_goods_drawer_submit_btn')}
    </Button>
  );
};

export default connect<MapStateProps, MapDispatchProps>(
  mapStateToProps,
  mapDispatchToProps,
)(memo(Index));
